import React from 'react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import { getIn } from 'formik'

import GoogleMediaUpload from '../GoogleMediaUpload'
import Button from '../../../../../../../../components/Button'
import FileDetailsPreview from '../../../../../../../../components/FileDetailsPreview'

import { useMultipleMediaUpload } from '../../../../../../../ReusableFormFields/AdFileUpload/hooks/useMultipleMediaUpload'

import { FILE_TYPE, FILE_URL, initialGoogleFile } from '../../../../../fields'
import { FILE_NAME } from '../../../../../../../ReusableFormFields/AdFileUpload/fields'

function MultipleGoogleMediaUpload({
  formik,
  FileItemPath,
  validationSchema,
  maxCount = 10,
  addAnotherButtonText = 'Add another image',
  width,
  height
}) {
  const { t } = useTranslation()

  const { values, setValues } = formik

  const carouselItems = getIn(values, FileItemPath)

  const { handleAddAnotherItem, handleDeleteItem } = useMultipleMediaUpload({
    carouselItems,
    maxCount,
    FileItemPath,
    initialFileValue: initialGoogleFile,
    setValues,
    values
  })

  const hasEmptyMedia = !!values[FileItemPath].find(item => !item[FILE_URL])

  return (
    <>
      {carouselItems.map((item, index) => {
        const itemPath = `${FileItemPath}[${index}]`
        const fileUrl = getIn(values, `${itemPath}.${FILE_URL}`)
        const fileName = getIn(values, `${itemPath}.${FILE_NAME}`)
        const filePreviewType = getIn(values, `${itemPath}.${FILE_TYPE}`)

        return fileUrl ? (
          <FileDetailsPreview
            key={index}
            fileUrl={fileUrl}
            fileName={fileName}
            filePreviewType={filePreviewType}
            isFileLoading={false}
            allowDelete={true}
            removeFile={() => handleDeleteItem(index)}
          />
        ) : (
          <GoogleMediaUpload
            key={index}
            formik={formik}
            itemPath={itemPath}
            fileValidationSchema={validationSchema}
            onMediaRemove={() => handleDeleteItem(index)}
            width={width}
            height={height}
          />
        )
      })}
      <br />
      {!hasEmptyMedia && carouselItems.length < maxCount && (
        <Button type="button" className="btnBlock" onClick={handleAddAnotherItem}>
          {t(addAnotherButtonText)}
        </Button>
      )}
    </>
  )
}

MultipleGoogleMediaUpload.propTypes = {
  formik: PropTypes.object.isRequired,
  FileItemPath: PropTypes.string.isRequired,
  validationSchema: PropTypes.object.isRequired,
  isStepFieldsValid: PropTypes.func,
  addAnotherButtonText: PropTypes.string
}

export default MultipleGoogleMediaUpload
